@if (config?.label) {
  <label class="form-control__label" [ngClass]="{ 'is-required': required }">
    <div class="u-flex u-alignBaseline u-maxX">
      <p class="t-data t-bold">
        {{ config?.label }}
        @if (required) {
          <span>*</span>
        }
      </p>
    </div>
  </label>
}

<div class="ssn-group__controls">
  @for (ctrl of ssnControlConfigs; track ctrl) {
    <form-control
      [group]="formGroup"
      [config]="ctrl"
      [control]="formGroup.get(ctrl.prop)"
    >
    </form-control>
  }
</div>

@if (errors) {
  <div class="u-flex ssn-group__error">
    <icon
      name="warning"
      [config]="{
        size: 'small',
        set: 'system',
        format: 'svg',
        color: 'error',
      }"
    >
    </icon>
    <p [attr.aria-label]="displayedError" class="t-caption t-error">
      {{ config.message }}
    </p>
  </div>
}
